import { atom } from "recoil";
import { localStorageEffect } from "./localStorageEffect";

export interface HomeSpot {
  regionId: string;
  cameraId: string;
  preferMultiCam?: boolean;
}

/**
 * The user's starred home spot — the break that loads on app startup.
 * null means nothing starred. Startup then follows the active region, or the
 * Flagler Beach report when the last viewed region was in Florida.
 */
export const homeSpotAtom = atom<HomeSpot | null>({
  key: "homeSpot",
  default: null,
  effects_UNSTABLE: [localStorageEffect("homeSpot")],
});

/** @deprecated kept for backward compat — remove after migration */
export const homeRegionAtom = homeSpotAtom;
